module.exports = __webpack_public_path__ + "static/media/232.5a32399f.wav";